export const operatorsStringPart = ['cont', 'not_cont', 'start', 'end']
export const operatorsList = ['eq', 'not_eq', 'null', 'not_null']
export const operatorsString = [...operatorsStringPart, 'eq', 'not_eq', 'null', 'not_null']
export const operatorsNumber = ['eq', 'not_eq', 'gt', 'lt', 'gteq', 'lteq', 'null', 'not_null']
export const operatorsDate = ['eq', 'eq_days', 'lt', 'gt', 'lteq', 'gteq', 'null', 'not_null']
export const operatorsBoolean = ['true', 'false']
export const operatorsHybrid = [...operatorsList, ...operatorsStringPart]
export const specialOperators = ['hierarchy']
